import { configureStore } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'
import { combineReducers } from 'redux'
import rootSaga from '@store/sagas/index'
import authenticationReducer from '@store/slices/Authentication.slice'
import dashboardReducer from '@store/slices/Dashboard.slice'

/* eslint-disable @typescript-eslint/no-var-requires */
let Reactotron: any
if (process.env.NODE_ENV === 'development') {
    Reactotron = require('@config/Reactotrone').default
} else {
    Reactotron = { createEnhancer: undefined }
}

const NODE_ENV = process.env.NODE_ENV
const sagaMiddleware = createSagaMiddleware()

const middlewares: any[] = [sagaMiddleware]

const reducers = combineReducers({
    authentication: authenticationReducer,
    dashboard: dashboardReducer,
})

export const store = configureStore({
    reducer: reducers,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: middlewares,
    enhancers: NODE_ENV === 'development' && Reactotron.createEnhancer 
        ? [Reactotron.createEnhancer()] 
        : undefined,
})

sagaMiddleware.run(rootSaga)

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch